export * from './item-branches.component';



// WEBPACK FOOTER //
// ./src/app/components/item-branches/index.ts